import { gql } from '@apollo/client';

export const PAGE_BATCH_PUSH_HISTORY = gql`
    query PageBatchPushHistory($request: BatchPushHistoryPageRequestInput!) {
        history: pageBatchPushHistory(request: $request) {
            totalPushCount
            totalParcelCount
            total
            pageNum
            pageSize
            content {
                pushRecordId
                pushedAt
                operatorName
                parcelCount
                batchCount
                childList {
                    wmsBatchNumber
                    displayNode
                    displayTime
                    parcelCount
                    areaCount
                }
            }
        }
    }
`;

export interface BatchPushHistoryBatch {
    wmsBatchNumber: string | null;
    displayNode: string | null;
    displayTime: string | null;
    parcelCount: number | null;
    areaCount: number | null;
}

export interface BatchPushHistoryItem {
    pushRecordId: number | null;
    pushedAt: string | null;
    operatorName: string | null;
    parcelCount: number | null;
    batchCount: number | null;
    childList: BatchPushHistoryBatch[];
}

export interface PageBatchPushHistoryResponse {
    history: {
        totalPushCount: number;
        totalParcelCount: number;
        total: number;
        pageNum: number;
        pageSize: number;
        content: BatchPushHistoryItem[];
    };
}

export interface PageBatchPushHistoryVariables {
    request: {
        warehouseId: number;
        startDate: string;
        endDate: string;
        pageNum: number;
        pageSize: number;
    };
}
